import { Download, FileText } from 'lucide-react';
import { Link } from 'react-router';

import { Button } from '@/components/shadcn/button';
import { toDateString } from '@/lib/utils/date';

import type { ClaimDocument, Document, InvoiceDocument } from '../../types';

type Props = {
  document: Document | InvoiceDocument | ClaimDocument;
};

export default function DocumentItem({ document }: Props) {
  return (
    <Link
      to={document.link}
      target="_blank"
      className="shadow-card flex items-center justify-between gap-2 rounded-lg border p-2"
    >
      <div className="flex flex-col overflow-x-hidden">
        <div className="flex items-center gap-1 text-sm leading-tight">
          <FileText className="size-3.5 shrink-0" />

          <span className="truncate whitespace-nowrap">
            {document.filename}
          </span>
        </div>

        <div className="text-muted-foreground text-xs">
          <span>
            {toDateString(
              'created_at' in document
                ? document.created_at
                : document.published_at,
            )}
          </span>
        </div>
      </div>

      <div className="shrink-0">
        <Button variant="ghost" size="icon-sm" asChild>
          <span>
            <Download />
          </span>
        </Button>
      </div>
    </Link>
  );
}
